import { StyleSheet, Dimensions, Platform } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

import images from '../../Themes/Images'

const { width: SCREEN_WIDTH } = Dimensions.get('window')


const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    position: 'relative',
    backgroundColor: Colors.whiteSmoke
  },
  headerBackground: {
    width: '100%',
    height: '100%',
    backgroundColor: Colors.vfRed,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  },
  container: {
    flex: 1,
  },
  headerOfferTitle: {
    marginHorizontal: 16
  },
  headerContentContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginVertical: 8,
  },
  fillRemainingSpace: {
    flexGrow: 1,
    flexShrink: 1
  },
  headerIcon: {
    tintColor: Colors.white,
    marginRight: 16,
    marginLeft: 8
  },
  row: {
    flexDirection: 'row',
    minWidth: 100,
    justifyContent: 'flex-end'
  },
  webView: {
    marginHorizontal: 8
  },
  scrollContainer: (bottomInset = 0, theme) => {
    return {
      flexGrow: 1,
      paddingBottom: bottomInset,
      backgroundColor: theme.colors.backgroundColor,
      // paddingHorizontal: Dimensions.get('window').width > 700 ? '10%' : 8
    }
  },
  scrollContainerWithSpace: (bottomInset = 0, theme) => {
    return {
      flexGrow: 1,
      paddingBottom: bottomInset + 16,
      justifyContent: 'space-between',
      // backgroundColor: theme.colors.backgroundColor
    }
  },
  timelineContainer: theme => ({
    padding: 16,
    backgroundColor: theme.colors.backgroundColor
  }),
  timelineIconContainer: {
    marginBottom: 4
  },
  timelineItemTitle: theme => ({
    padding: 0,
    fontSize: 16,
    color: theme.colors.textColor
  }),
  timelineActiveItemTitle: theme => ({
    color: theme.colors.textColor
  }),
  viewPager: theme => ({
    flexGrow: 1,
    backgroundColor: 'black'
  }),
  sectionTitle: {
    margin: 16,
    marginTop: 32
  },
  firstCardStyle: {
    marginHorizontal: 16,
    marginTop: 32,
    marginBottom: 0,
    padding: 0
  },
  cardStyle: {
    margin: 16,
    marginBottom: 0,
    padding: 0
  },
  cardContentContainer: {
    paddingVertical: 0
  },
  mySelection: {
    marginTop: 0
  },
  collapsedContent: theme => ({
    // backgroundColor: theme.colors.whiteSmoke,
    paddingBottom: 16
  }),
  extraListContainer: {
    margin: 16,
    marginRight: 0
  },
  options: {
    marginHorizontal: 12,
    marginBottom: 16
  },
  firstButton: {
    margin: 16,
    marginTop: 32,
    marginBottom: 0
  },
  lastButton: {
    margin: 16,
    marginTop: 32
  },
  button: {
    margin: 16,
    marginBottom: 0
  },
  cancelButton: {
    margin: 16
  },
  collapsedContent2: {
    paddingHorizontal: 16,
    // backgroundColor: Colors.white
  },
  titleStyle: theme => ({
    ...Fonts.type.bold,
    // color: theme.colors.textColor
  }),
  titleStyle2: {
    fontSize: 14
  },
  descStyles2: {
    fontSize: 18,
    ...Fonts.type.bold
  },
  toggleAllContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
    marginRight: 16,
    paddingTop: 32,
    paddingBottom: 0,
    flexShrink: 1
  },
  viewTermsLink: {
    flexGrow: 1,
    flexShrink: 1
  },
  viewTermsText: {
    flexShrink: 1,
    textDecorationLine: 'underline',
    flexWrap: 'wrap'
  },
  full: {
    flex: 1
  },
  fill: {
    flexGrow: 1,
    flexShrink: 1
  },
  modalHeaderContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginHorizontal: 16,
    marginTop: 24,
    marginBottom: 16
  },
  inputContainer: {
    minHeight: 50
  },
  extraTitleStyle: {
    marginTop: 2,
    fontSize: 14
  },
  checkBoxStyle: {
    marginTop: 12,
    marginRight: 12,
    marginLeft: 4
  },
  extraIconStyle: {
    margin: 4,
    marginVertical: 8,
    tintColor: Colors.mustardGreen,
    width: 16,
    height: 16
  },
  termsRowStyle: {
    borderTopColor: Colors.veryLightPink,
    borderTopWidth: 1,
    borderStyle: 'solid',
    paddingVertical: 16
  },
  bottomText: {
    margin: 16
  },
  secondaryButton: {
    marginTop: 16
  },
  textSpacing: {
    marginHorizontal: 16,
    marginVertical: 8
  },
  horizontalSpacing: {
    marginHorizontal: 16
  },
  cardContentContaoner3: {
    padding: 8,
    paddingBottom: 18,
    overflow: 'hidden'
  },
  radioGroup: {
    marginTop: 16
  },
  summary: (bottom = 0, theme) => {
    return {
      marginTop: 32,
      paddingBottom: bottom,
      backgroundColor: theme.colors.backgroundColor
    }
  },
  separator: {
    margin: 16,
    backgroundColor: Colors.veryLightPink
  },
  sumaryDetailsrowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8
  },
  iconHIFI: {
    width: 42,
    height: 42
  },
  verificationCodeSentTitle: {
    fontSize: 14,
    marginTop: 12
  },
  verificationCodeSentContainer: {
    margin: 16,
    marginBottom: 24,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.veryLightPink,
    borderStyle: 'solid'
  },
  touchableText: {
    textDecorationLine: 'underline'
  },
  icon: {
    resizeMode: 'contain'
  },
  verificationRowIcon: {
    width: 32,
    height: 32,
    resizeMode: 'contain',
    tintColor: Colors.gray65
  },
  deleteIcon: {
    tintColor: Colors.red
  },
  verificationRowText: {
    fontSize: 18,
    marginTop: 20
  },
  buttonInCard: {
    margin: 8,
    marginTop: 16
  },
  capturedImageContainer: {
    width: SCREEN_WIDTH - 64,
    height: SCREEN_WIDTH - 64,
    borderRadius: 10,
    overflow: 'hidden',
    margin: 8,
    marginTop: 16
  },
  capturedImage: {
    resizeMode: 'cover'
  },
  scannedImageText: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  cameraContainer: {
    width: '100%',
    height: '100%',
    position: 'relative'
  },
  camera: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  overlayMask: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: Colors.blackRGBA(0.75)
  },
  overlayMaskOutline: {
    position: 'absolute',
    left: 16,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Colors.white
  },
  cameraControlContainer: {
    width: '100%',
    minHeight: 100,
    backgroundColor: Colors.white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    marginTop: -10
  },
  cameraControlHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 32,
    marginHorizontal: 16,
    marginBottom: 8
  },
  takePictureOuter: {
    width: 64,
    height: 64,
    backgroundColor: Colors.lightGrayTwo,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 32
  },
  takePictureInner: {
    width: 50,
    height: 50,
    backgroundColor: Colors.gray65,
    borderRadius: 25
  },
  modal: {
    marginBottom: 0
  },
  termsModal: {
    height: '80%'
  },
  takePictureContainer: {
    margin: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },

  // Input styles
  inputText: {
    fontFamily: Fonts.type.VFFont,
  },

  // Modal non scrollable content
  modalContentContainerWraper: theme => ({
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingVertical: 32,
    backgroundColor: theme.colors.backgroundColor
  }),
  modalContentWraper: {
    flexGrow: 1,
    marginTop: 64,
    justifyContent: 'center',
    alignItems: 'center'
  },
  verticalSpacing: {
    marginTop: 35,
    marginBottom: 16
  },
  modalContentWraper2: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },

  offerDetailsContainer: {
    marginBottom: 32
  },
  offerDetailsContent: {
    margin: 16,
    marginTop: 32,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  iosCheckBoxStyle: {
    height: 20,
    width: 20,
    marginVertical: 18,
    marginHorizontal: 16
  },
  lottieWrapper: {
    height: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center'
  },
  lottie: {
    width: 150,
    height: 150,
    marginLeft: 0,
    alignSelf: 'center'
  }
})

const extraIcon = images.tickConfirm

const checkBoxTintcolors = {
  true: Colors.ocean,
  false: Colors.veryLightPink
}

const timelineTitleProps = {
  numberOfLines: 1,
  ellipsizeMode: 'clip'
}

export default styles
export { timelineTitleProps, checkBoxTintcolors, extraIcon }
